import { doc, getDoc } from 'firebase/firestore'
import type { CountKey, SettingKey } from '#shared/types/Setting'
import { useFirebase } from '@/composables/firebase/useFirebase'

export type OpportunitiesCountType = {
    users: number
    orgs: number
    opportunities: number
}

/**
 * Composable for settings-related operations
 */
export function useSettings() {
    const { collections } = useFirebase()

    /**
     * Fetches a setting by key with an optional default value
     */
    async function fetchSetting(key: SettingKey, defaultValue?: any): Promise<any> {
        try {
        
            const docRef = doc(collections.settings, key)
            const docSnap = await getDoc(docRef)
        
        
            return docSnap.exists() ? docSnap.data()?.value : defaultValue
        } catch (error) {
            console.error("[useSettings composable] Error fetching setting:", error)
            return defaultValue
        }
    }

    /**
     * Fetches opportunities count by key with an optional default value
     */
    async function fetchOpportunitiesCount(key: CountKey, defaultValue?: OpportunitiesCountType): Promise<any> {
        return (await getDoc(doc(collections.settings, key))).data() || defaultValue
    }

    return {
        fetchSetting,
        fetchOpportunitiesCount
    }
}
